/** Build public S3 asset URLs from the keys returned by the API. */
export function useStorageUrl() {
  const config = useRuntimeConfig()
  const base = (config.public.s3BaseUrl || '').replace(/\/+$/, '')

  return (path?: string | null): string | null => {
    if (!path) return null
    if (/^https?:\/\//i.test(path)) return path
    const clean = path.startsWith('/') ? path : `/${path}`
    return base ? `${base}${clean}` : clean
  }
}
